import { USER_REQUEST, USER_ERROR, USER_SUCCESS, USER_UPDATE, UPDATE_ERROR, UPDATE_SUCCESS, USER_NOTIFICATIONS, CHANGE_VIEWMODE } from '../actions/user';
import Vue from 'vue';
import { AUTH_LOGOUT } from '@/utils/store/actions/auth';
import apiCall from '@/utils/api_call';
import { ApiDefaults } from '@/utils/api_call';

const state = {status: '', profile: {}, viewMode: 'dark'};

const getters = {
    getProfile: ( state ) => state.profile,
    getProfileImage: ( state ) => state.profile.image,
    isProfileLoaded: ( state ) => state.profile.hasOwnProperty('firstName'),
    isSubscribed: ( state ) => state.profile.hasOwnProperty('push_endpoint'),
    getLastLogin: function ( state ) {
        if ( !state.profile.hasOwnProperty('last_login') ) {
            return null;
        }
        else {
            return new Date(state.profile.last_login.date);
        }
    },
    getViewMode: ( state ) => state.viewMode
};

const actions = {
    [ USER_REQUEST ]: ( {commit, dispatch} ) => {
        commit(USER_REQUEST);

        let profile = JSON.parse(localStorage.getItem('tmp-profile'));
        profile.fullName = profile.firstName + ' ' + profile.lastName;
        // if ( profile.image === '' ) {
        //     profile.image = require('@/assets/images/icons/ic_profil.svg');
        // }
        // remove token and uid from localstorage
        delete profile.token;
        // delete profile.uid;
        delete profile.username;

        commit(USER_SUCCESS, profile);
    },
    [ USER_UPDATE ]: ( {commit, state}, profileSettings ) => {

        return new Promise(( resolve, reject ) => {
            let postData = new FormData(),
                user = state.profile.uid;

            postData.append('tx_c3json_jsondataplugin[user][uid]', user);

            postData.append('tx_c3json_jsondataplugin[controller]', 'JsonDataUser');
            postData.append('tx_c3json_jsondataplugin[action]', 'update');


            if ( typeof profileSettings.image !== undefined )
                postData.append('image', profileSettings.image);

            let apiParams = Object.assign({}, ApiDefaults,
                {
                    method: 'post',
                    params: {
                        id: 1
                    },
                    data: postData,
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });

            apiCall(apiParams)
                .then(( response ) => {

                    if ( response.status === 200 ) {
                        let tmpProfile = {
                            // darkMode : false
                            image: response.data.user.image
                        };

                        commit(UPDATE_SUCCESS, tmpProfile);
                        resolve(tmpProfile);
                    }
                })
                .catch(( err ) => {

                    commit(UPDATE_ERROR);
                    reject(new Error('Profile update failed'));
                });


        });

    }
};

const mutations = {
    [ USER_REQUEST ]: ( state ) => {
        state.status = 'loading';
    },
    [ USER_SUCCESS ]: ( state, response ) => {
        state.status = 'success';
        Vue.set(state, 'profile', response);
    },
    [ USER_ERROR ]: ( state ) => {
        state.status = 'error';
    },
    [ AUTH_LOGOUT ]: ( state ) => {
        state.profile = {};
        state.status = 'logged_out';
    },
    [ USER_UPDATE ]: ( state ) => {
        state.status = 'updating';
    },
    [ UPDATE_SUCCESS ]: ( state, newProfile ) => {
        state.status = 'success';
        state.profile = Object.assign(state.profile, newProfile);
        localStorage.setItem( 'tmp-profile', JSON.stringify( state.profile ) );
    },
    [ UPDATE_ERROR ]: ( state ) => {
        state.status = 'error';
    },
    [ USER_NOTIFICATIONS ]: ( state ) => {
        state.profile.push_endpoint = true;
    },
    [ CHANGE_VIEWMODE ]: ( state ) => {
        state.viewMode = (state.viewMode === 'dark' ? 'light' : 'dark');
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/utils/store/modules/user.js